import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../../context/LanguageContext";

interface LocalizedLinkProps {
  to: string;
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

const LocalizedLink: React.FC<LocalizedLinkProps> = ({
  to,
  children,
  className,
  onClick,
}) => {
  const { getLocalizedPath } = useLanguage();

  return (
    <Link to={getLocalizedPath(to)} className={className} onClick={onClick}>
      {children}
    </Link>
  );
};

export default LocalizedLink;
